"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var findNestedDynamicProxies = function (children) {
    if (!children)
        return false;
    for (var childProxyKey in children) {
        var _a = children[childProxyKey], proxy = _a.proxy, proxyChildren = _a.children;
        // Return true on first encounter and break further iteration
        if (proxy._isDynamic)
            return true;
        if (proxyChildren) {
            // Check other nested (non dynamic) proxies objects recursively incase
            // dynamic proies are more deeply nested
            var hasNestedDynamicProxies = findNestedDynamicProxies(proxyChildren);
            if (hasNestedDynamicProxies)
                return true;
        }
    }
    return false;
};
exports.default = findNestedDynamicProxies;
//# sourceMappingURL=findNestedDynamicProxies.js.map